// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MedRadaPages_wrapper__MjlN4 {
  display: flex;
  padding: 50px 100px;
  background-color: #f7f7f7;
  border-radius: 16px;
  width: 100%;
}

.MedRadaPages_image__q3cVb {
  width: 14%;
}

.MedRadaPages_h1__R8HoY {
  font-family: "Open Sans";
  font-weight: 700;
  letter-spacing: 0px;
  text-align: left;
  font-size: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  overflow-wrap: break-word;
  color: #47a9f4;
  padding-left: 15px;
  width: -moz-fit-content;
  width: fit-content;
}

.MedRadaPages_start__jU34F {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.MedRadaPages_right__5fL5j {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 25%;
}

.MedRadaPages_left__1bVPB {
  padding-left: 20px;
}

.MedRadaPages_content__P5apc {
  max-width: 100%;
}

.MedRadaPages_btn1__VQ6sw,
.MedRadaPages_btn2__qpMZz {
  padding: 16px 24px 16px 24px;
  border-radius: 8px;
  border: none;
  gap: 8px;
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 350px;
}

.MedRadaPages_btn1__VQ6sw {
  background-color: #47a9f4;
  color: white;
}

.MedRadaPages_btn2__qpMZz {
  background-color: transparent;
  color: #47a9f4;
  border: 2px solid #47a9f4;
  padding-right: 40px;
}

.MedRadaPages_btntext__0r4eP,
.MedRadaPages_natrag__l966A {
  font-size: 16px;
  font-family: "Open Sans";
  font-weight: 700;
}

.MedRadaPages_btn1__VQ6sw:hover,
.MedRadaPages_btn2__qpMZz:hover,
.MedRadaPages_btn__k\\+RC0 {
  cursor: pointer;
}

.MedRadaPages_btn1__VQ6sw:hover {
  background-color: #3175a8;
}

.MedRadaPages_btn2__qpMZz:hover {
  background-color: #e6eaed;
}

.MedRadaPages_natrag__l966A {
  color: #5f6d7e;
}

.MedRadaPages_btnback__bQWxJ {
  height: 24px;
  width: 24px;
}

.MedRadaPages_btn__k\\+RC0 {
  display: flex;
  border: none;
  width: 60%;
  height: 60px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #e6eaed;
}

.MedRadaPages_li__kQDOC,
.MedRadaPages_p__xYnB2,
.MedRadaPages_h3__7BD-F {
  font-size: 16px;
  font-family: "Open Sans";
  color: #747474;
}

.MedRadaPages_h3__7BD-F {
  font-weight: 700;
}

.MedRadaPages_list__swHul {
  color: #747474;
}

.MedRadaPages_btnimg1__Maxqm,
.MedRadaPages_btnimg2__gX1U\\+ {
  height: 24px;
  width: 24px;
}

@media screen and (max-width: 1350px) {
  .MedRadaPages_h1__R8HoY {
    font-size: 22px;
  }
  .MedRadaPages_btn__k\\+RC0 {
    width: 80%;
  }
  .MedRadaPages_wrapper__MjlN4 {
    margin-right: 50px;
    width: 95%;
  }
}

@media screen and (max-width: 1200px) {
  .MedRadaPages_wrapper__MjlN4 {
    flex-direction: column;
  }
  .MedRadaPages_left__1bVPB,
  .MedRadaPages_right__5fL5j {
    width: 90%;
  }
  .MedRadaPages_right__5fL5j {
    padding-left: 20px;
    align-items: flex-start;
  }
  .MedRadaPages_btn__k\\+RC0 {
    width: 350px;
  }
}

@media screen and (max-width: 1110px) {
  .MedRadaPages_wrapper__MjlN4 {
    width: 87%;
  }
}

@media screen and (max-width: 870px) {
  .MedRadaPages_wrapper__MjlN4 {
    width: 92%;
    padding: 50px 50px;
  }
}

@media screen and (max-width: 500px) {
  .MedRadaPages_left__1bVPB {
    width: 95%;
    padding-left: 0px;
  }
  .MedRadaPages_wrapper__MjlN4 {
    padding: 40px 30px;
    width: 100%;
  }
  .MedRadaPages_right__5fL5j {
    padding-left: 0;
  }
}

@media screen and (max-width: 430px) {
  .MedRadaPages_btn__k\\+RC0,
  .MedRadaPages_btn1__VQ6sw,
  .MedRadaPages_btn2__qpMZz {
    width: 300px;
  }
  .MedRadaPages_btn__k\\+RC0 {
    margin-top: 50px;
  }
}

@media screen and (max-width: 376px) {
  .MedRadaPages_btn__k\\+RC0,
  .MedRadaPages_btn1__VQ6sw,
  .MedRadaPages_btn2__qpMZz {
    width: 250px;
    margin-left: 11%;
  }
  .MedRadaPages_btn__k\\+RC0 {
    margin-top: 50px;
  }
  .MedRadaPages_wrapper__MjlN4 {
    padding-left: 20px;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/MedRadaPages/MedRadaPages.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;EAGE,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  padding: 50px 100px;\n  background-color: #f7f7f7;\n  border-radius: 16px;\n  width: 100%;\n}\n\n.image {\n  width: 14%;\n}\n\n.h1 {\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  letter-spacing: 0px;\n  text-align: left;\n  font-size: 24px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  overflow-wrap: break-word;\n  color: #47a9f4;\n  padding-left: 15px;\n  width: fit-content;\n}\n\n.start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.right {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-left: 25%;\n}\n\n.left {\n  padding-left: 20px;\n}\n\n.content {\n  max-width: 100%;\n}\n\n.btn1,\n.btn2 {\n  padding: 16px 24px 16px 24px;\n  border-radius: 8px;\n  border: none;\n  gap: 8px;\n  width: 100%;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 350px;\n}\n\n.btn1 {\n  background-color: #47a9f4;\n  color: white;\n}\n\n.btn2 {\n  background-color: transparent;\n  color: #47a9f4;\n  border: 2px solid #47a9f4;\n  padding-right: 40px;\n}\n\n.btntext,\n.natrag {\n  font-size: 16px;\n  font-family: \"Open Sans\";\n  font-weight: 700;\n}\n\n.btn1:hover,\n.btn2:hover,\n.btn {\n  cursor: pointer;\n}\n\n.btn1:hover {\n  background-color: #3175a8;\n}\n\n.btn2:hover {\n  background-color: #e6eaed;\n}\n\n.natrag {\n  color: #5f6d7e;\n}\n\n.btnback {\n  height: 24px;\n  width: 24px;\n}\n\n.btn {\n  display: flex;\n  border: none;\n  width: 60%;\n  height: 60px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  background-color: #e6eaed;\n}\n\n.li,\n.p,\n.h3 {\n  font-size: 16px;\n  font-family: \"Open Sans\";\n  color: #747474;\n}\n\n.h3 {\n  font-weight: 700;\n}\n\n.list {\n  color: #747474;\n}\n\n.btnimg1,\n.btnimg2 {\n  height: 24px;\n  width: 24px;\n}\n\n@media screen and (max-width: 1350px) {\n  .h1 {\n    font-size: 22px;\n  }\n  .btn {\n    width: 80%;\n  }\n  .wrapper {\n    margin-right: 50px;\n    width: 95%;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .wrapper {\n    flex-direction: column;\n  }\n  .left,\n  .right {\n    width: 90%;\n  }\n  .right {\n    padding-left: 20px;\n    align-items: flex-start;\n  }\n  .btn {\n    width: 350px;\n  }\n}\n\n@media screen and (max-width: 1110px) {\n  .wrapper {\n    width: 87%;\n  }\n}\n\n@media screen and (max-width: 870px) {\n  .wrapper {\n    width: 92%;\n    padding: 50px 50px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .left {\n    width: 95%;\n    padding-left: 0px;\n  }\n  .wrapper {\n    padding: 40px 30px;\n    width: 100%;\n  }\n  .right {\n    padding-left: 0;\n  }\n}\n\n@media screen and (max-width: 430px) {\n  .btn,\n  .btn1,\n  .btn2 {\n    width: 300px;\n  }\n  .btn {\n    margin-top: 50px;\n  }\n}\n\n@media screen and (max-width: 376px) {\n  .btn,\n  .btn1,\n  .btn2 {\n    width: 250px;\n    margin-left: 11%;\n  }\n  .btn {\n    margin-top: 50px;\n  }\n  .wrapper {\n    padding-left: 20px;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MedRadaPages_wrapper__MjlN4`,
	"image": `MedRadaPages_image__q3cVb`,
	"h1": `MedRadaPages_h1__R8HoY`,
	"start": `MedRadaPages_start__jU34F`,
	"right": `MedRadaPages_right__5fL5j`,
	"left": `MedRadaPages_left__1bVPB`,
	"content": `MedRadaPages_content__P5apc`,
	"btn1": `MedRadaPages_btn1__VQ6sw`,
	"btn2": `MedRadaPages_btn2__qpMZz`,
	"btntext": `MedRadaPages_btntext__0r4eP`,
	"natrag": `MedRadaPages_natrag__l966A`,
	"btn": `MedRadaPages_btn__k+RC0`,
	"btnback": `MedRadaPages_btnback__bQWxJ`,
	"li": `MedRadaPages_li__kQDOC`,
	"p": `MedRadaPages_p__xYnB2`,
	"h3": `MedRadaPages_h3__7BD-F`,
	"list": `MedRadaPages_list__swHul`,
	"btnimg1": `MedRadaPages_btnimg1__Maxqm`,
	"btnimg2": `MedRadaPages_btnimg2__gX1U+`
};
export default ___CSS_LOADER_EXPORT___;
